import { platformMap } from '../../constants';
import { titleCaseFromCamel } from '../../utils';

export const TransactionStatus = {
  /** Initial/starting state for DI */
  Upcoming: 'Upcoming',
  /** Initial/starting state for TA */
  Confirmed: 'Confirmed',
  /** Final state for DI */
  Paid: 'Paid',
  /** Final state for TA */
  Completed: 'Completed',
};

export const getAvailableTypes = (platform) => {
  const types = [
    { value: 'all', label: 'All' },
    ...(platform === platformMap.eatclub.value ? [{ value: 'dineIn', label: 'Dine-In' }] : []),
    { value: 'takeAway', label: 'Takeaway' },
    ...(platform === platformMap.whitelabel.value
      ? [{ value: 'tableOrder', label: 'Table Order' }]
      : []),
  ];

  return types;
};

export const formatType = (type) => {
  switch (type) {
    case 'inAppOrder':
      return 'In-App Order';
    case 'dineIn':
      return 'Dine-In';
    case 'takeAway':
      return 'Takeaway';
    case 'tableOrder':
      return 'Table Order';
    default:
      return type;
  }
};

export const formatStatus = (type, status) => {
  if (type === 'dineIn') {
    if (status === 'Confirmed') {
      return 'Upcoming'; // adds more context to the confirmed state for Dine-In
    }
  }

  return status;
};

export const formatIssueStatus = (issueStatus) => {
  if (issueStatus === 'partySizeReported') {
    return 'Party Size Changed';
  }
  return titleCaseFromCamel(issueStatus);
};

export const getOverviewPanelTabs = (transaction, bookingReceipts) => {
  const allTabs = [];

  const isEatClubPlatform = transaction?.platform === platformMap.eatclub.value;
  if (isEatClubPlatform) {
    allTabs.push({ label: 'Overview', value: 'overview' });
  }

  if (bookingReceipts.data.results?.length > 0) {
    const isMultiReceipt = bookingReceipts.data.results?.length > 1;
    bookingReceipts.data.results?.forEach((_, i) => {
      allTabs.push({
        label: !isMultiReceipt ? 'Receipt' : `Receipt ${i + 1}`,
        value: i,
      });
    });
  }

  const hasOrder = !!transaction?.orderId;
  if (hasOrder) {
    allTabs.push({ label: 'Items', value: 'items' });
  }

  return allTabs;
};

export const processInAppPaymentItems = (inAppPaymentItems) => {
  const processedItems = inAppPaymentItems.reduce(
    (acc, curr) => {
      if (curr.offerAppliedBy === 'eatclub') {
        const prevTotal = curr.origPrice * curr.qty;
        const total = curr.venuePrice * curr.qty;

        const wasAdjusted = curr.origPrice > curr.inHousePrice && curr.price < curr.inHousePrice;

        acc.ecApplied.prevTotal += prevTotal;
        acc.ecApplied.total += total;

        acc.ecApplied.items.push({
          ...curr,
          prevTotal,
          total,
          wasAdjusted,
        });
      }

      if (curr.offerAppliedBy === 'venue') {
        const prevTotal = curr.origPrice * curr.qty;
        const total = curr.price * curr.qty;

        acc.venueApplied.prevTotal += prevTotal;
        acc.venueApplied.total += total;

        acc.venueApplied.items.push({
          ...curr,
          prevTotal,
          total,
        });
      }

      if (curr.offerAppliedBy === 'exclude') {
        const total = curr.origPrice * curr.qty;

        acc.excluded.total += total;
        acc.excluded.items.push({
          ...curr,
          total,
        });
      }

      return acc;
    },
    {
      ecApplied: {
        prevTotal: 0,
        total: 0,
        items: [],
      },
      venueApplied: {
        prevTotal: 0,
        total: 0,
        items: [],
      },
      excluded: {
        total: 0,
        items: [],
      },
    },
  );

  return processedItems;
};
